<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <polygon class="fil0" points="3563.05,1622.76 2827.51,1622.76 3399.05,1051.22 3150.31,800.75 2328.3,1622.76 1975.56,1622.76 1975.56,1269.95 2797.57,447.94 2547.1,199.2 1975.56,770.81 1975.56,35.27 1622.76,35.27 1622.76,770.81 1051.28,199.27 800.81,448.01 1622.76,1269.95 1622.76,1622.76 1269.95,1622.76 448.01,800.81 199.27,1051.28 770.81,1622.76 35.27,1622.76 35.27,1975.56 770.81,1975.56 199.27,2547.1 448.01,2797.57 1269.95,1975.56 1622.76,1975.56 1622.76,2328.37 800.75,3150.38 1051.22,3399.12 1622.76,2827.51 1622.76,3563.05 1975.56,3563.05 1975.56,2827.51 2547.1,3399.05 2797.57,3150.31 1975.56,2328.3 1975.56,1975.5 2328.3,1975.56 3150.31,2797.57 3399.05,2547.1 2827.51,1975.56 3563.05,1975.56 "/>
 </g>
</svg>
